import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';
import Button from '@material-ui/core/Button';
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";



//images
import closeIcon from '../../../assets/images/modals/close-icon.png';
import wrongIcon from '../../../assets/images/test/wrong-answer.png';
import correctIcon from '../../../assets/images/test/correct-answer.png';
import { useAuthDataContext } from '../../../__providers/AuthProvider';

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            {...other}
        >
            {value === index && <Box p={2}>{children}</Box>}
        </Typography>
    );
}

function WrongAnswers(props, ref) {
    const [state, setState] = useState({
        modal: false,
        overlay: false,
        data: {}
    })

    const auth = useAuthDataContext();

    const [value, setValue] = useState(0);

    const [reviewAnswers, setReviewAnswers] = useState({
        showCorrect: false,
        correctId: null,
    });

    useEffect(() => {
        setValue(0);
    }, [state.data]);

    const handleClose = () => {
        props.cancelCallback && props.cancelCallback(false)

        setState(prev => ({
            ...prev,
            modal: false
        }))
        setTimeout(() => {
            setState(prev => ({
                ...prev,
                overlay: false,
                data: {}
            }))
        }, 50)
    }

    const handleShowCorrect = (e) => {
        let correct = e.target.getAttribute('data-id');
        setReviewAnswers(reviewAnswers => {
            return {
                ...reviewAnswers,
                showCorrect: true,
                correctId: correct,
            }
        })
    }

    const handleChange = (e, newValue) => {
        setValue(newValue);
    };

    useImperativeHandle(ref, data => ({
        open: data => handleOpen(data),
        close: () => handleClose()
    }))

    const handleOpen = data => {
        setState(prev => ({
            ...prev,
            overlay: true,
            data: data || state.data
        }))
        setTimeout(() => {
            setState(prev => ({
                ...prev,
                modal: true
            }))
        }, 100)
    }

    return (
        <div id="overlay" className={`scrollable-mobile ${props.blur || state.overlay ? 'visible' : ''}`}>
            <ul className={`wrong-answers-box ${props.popup || state.modal ? 'show' : ''}`}>
                <img src={closeIcon} alt="close" className="close" onClick={handleClose} />
                {state.data === undefined || props.loading
                    ?
                    <li className="current-question">
                        <Skeleton className="statistics-skeleton" />
                        <Skeleton className="question-skeleton" />
                        <Skeleton className="question-skeleton" />
                        <hr />
                        <Skeleton className="answer-skeleton" style={{ marginTop: 45 }} />
                        <Skeleton className="answer-skeleton" />
                        <Skeleton className="answer-skeleton" />
                        <Skeleton className="answer-skeleton" />
                    </li>
                    :

                    state.data[0] ?
                        state.data.map((each, i) =>

                            <TabPanel key={i} value={value} index={i}>
                                <li className="current-question">
                                    <div className="statistic">
                                        <p>
                                            Верни {each.correct_count}
                                        </p>
                                        <p>
                                            Точки {each.points}
                                        </p>
                                        {props.private ?
                                            ''
                                            :
                                            <div className="failed-students">
                                                Сгрешен от {each.wrong_by} човека
                                        <ul>
                                                    {each.wrong_by_students.map((student, i) =>
                                                        <li key={i}>
                                                            {student.name} {student.lastname}
                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                    <h3>
                                        {each.quest}
                                    </h3>
                                    <hr />
                                    <div id="answers" className="answers-wrapper">
                                        <ul className={`answers ${each.type === 1 ? 'question-with-image' : each.type === 2 ? 'answers-with-image' : ''}`}>
                                            {each.type === 1 ?
                                                <picture className="big-image">
                                                    <img src={each.picture + '?token=' + auth.user.token} alt="big image" />
                                                </picture>
                                                :
                                                ''}
                                            <div className="answers-holder">
                                                {each.answers.map((answer, i) =>
                                                    answer.picture != null ?
                                                        <li key={i} className={reviewAnswers.showCorrect == true && reviewAnswers.correctId == each.id ? answer.is_correct == 1 ? 'correct' : '' : ''}>
                                                            <picture style={{ backgroundImage: "url(" + answer.picture + '?token=' + auth.user.token + ")" }}>
                                                                {/* <img src={question.picture + '?token=' + auth.user.token} alt="big image" /> */}
                                                            </picture>
                                                            {props.private ? answer.is_correct == 1 || answer.correct == 1 ? <img src={correctIcon} alt="icon" className="check" /> : <img src={wrongIcon} alt="icon" className="check" /> : reviewAnswers.showCorrect == true && reviewAnswers.correctId == each.id ? answer.is_correct == 1 ? <img src={correctIcon} alt="icon" className="check" /> : <img src={wrongIcon} alt="icon" className="check" /> : ''}
                                                        </li>
                                                        :
                                                        <li key={i} className={[answer.is_checked == 1 ? 'checked' : '', reviewAnswers.showCorrect == true && reviewAnswers.correctId == each.id ? answer.is_correct == 1 ? 'correct' : '' : ''].join(' ')}>
                                                            <span>
                                                                {answer.answer}
                                                            </span>
                                                            {props.private ? answer.is_correct == 1 || answer.correct == 1 ? <img src={correctIcon} alt="icon" className="check" /> : <img src={wrongIcon} alt="icon" className="check" /> : reviewAnswers.showCorrect == true && reviewAnswers.correctId == each.id ? answer.is_correct == 1 ? <img src={correctIcon} alt="icon" className="check" /> : <img src={wrongIcon} alt="icon" className="check" /> : ''}
                                                        </li>
                                                )}
                                            </div>
                                        </ul>
                                    </div>
                                    {props.private ?
                                        ''
                                        :
                                        <Button data-id={each.id} className="show-correct" onClick={handleShowCorrect}>
                                            Покажи верните
                                        </Button>}
                                </li>
                            </TabPanel>
                        )
                        :
                        <p className="no-data">Все още няма сгрешени въпроси</p>

                }

                {!props.loading && state.data.length && !props.private
                    ?
                    <>
                        <hr />
                        <Tabs
                            orientation="horizontal"
                            variant="scrollable"
                            value={value}
                            onChange={handleChange}
                            aria-label="horizontal tabs example"
                        >
                            {state.data.map((each, i) =>
                                <Tab key={i} label={
                                    <div className="pages">
                                        <div className={each.type === 1 ? 'question-with-image' : each.type === 2 ? 'answers-with-image' : 'text-only'}>
                                            <p>
                                                {each.number}
                                            </p>
                                            <p className="mini-tests">
                                                {each.type === 1 ?
                                                    <span key={i}>
                                                        <img src={each.thumbnail + '?token=' + auth.user.token} alt="picture" />
                                                    </span>
                                                    :
                                                    each.answers.map((answer, i) =>
                                                        <span data-id={i} key={i}>
                                                            {answer.picture ?
                                                                <img src={answer.thumbnail + '?token=' + auth.user.token} alt="picture" />
                                                                :
                                                                ''
                                                            }
                                                        </span>
                                                    )}
                                            </p>
                                        </div>
                                    </div>
                                } />
                            )}
                        </Tabs>
                    </>

                    : ''
                }

            </ul>
        </div >
    )
}
export default forwardRef(WrongAnswers)